import React from "react";
import { styled } from "@volkswagen-onehub/components-core";
import { ArrayFilter, Filters } from "../../types/filters";
import { ColourSwatch } from "./ColourSwatch";
import { getLang } from "../../translations";
import handleClick from "../../utils/handle-click";
import { ColourFilterOption } from "../../types/globalapi/filters";
import { useSelectedFilterStore } from "../../store/filtersv2";

interface Props {
  label: string;
  type: keyof Filters;
  list: ColourFilterOption[];
  id: string;
}

const ColourSwatches = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
`;

const ColourSetFieldsetWrapper = styled.div`
  // margin: 0 -18px 0;
  // width: calc(100% + 36px);
  // legend {
  //   font-size: ${props => props.theme.fonts.bigcopy[100].fontSize};
  //   line-height: ${props => props.theme.fonts.bigcopy[100].lineHeight};
  //   letter-spacing: ${props => props.theme.fonts.bigcopy[100].letterSpacing};
  //   color: #001E50 !important;
  // }
  // [aria-live] {
  //   margin: 0;
  // }
`;

export const ColourSet = ({ label, type, list, id }: Props) => {
  const lang = getLang();
  const selection: string[] = useSelectedFilterStore().selected[type] as ArrayFilter || [];

  const handleClickEvent = handleClick(label, type);

  return (
    list
    && <ColourSetFieldsetWrapper>
        <ColourSwatches>
          {
            list.map(({label, value, hex_code}: ColourFilterOption, i: number) => {
              const key = `${id}-${i}`;
              return (
                <ColourSwatch
                  key={key}
                  name={type}
                  label={label[lang]}
                  value={value}
                  color={hex_code}
                  checked={selection.includes(value)}
                  onClick={handleClickEvent}
                />
              )
            })
          }
        </ColourSwatches>
    </ColourSetFieldsetWrapper>
  );
};
